import { InjectionToken } from '@angular/core';
import { BrightcoveConfiguration } from './brightcove-player/brightcove-player.domain';

export const BRIGHTCOVE_CONFIGURATION = new InjectionToken<BrightcoveConfiguration>('birghtcoveConfiguration');

export const PAGE_OFFSET_CONFIGURATION = new InjectionToken<number>('pageOffsetConfiguration');
